import { Box, Flex } from 'rebass';
import React, { useState } from 'react';
import { useRouter } from 'next/router';

import { StorySocialCount } from './SocialCount';
import CoverHeader from './header/CoverHeader';
import CtaBanner from './cta/CtaBanner';
import CtaFooter from './cta/CtaFooter';
import StoryPages from './StoryPages';
import CtaHeader from './cta/CtaHeader';
import useNoWrapper from './hooks/useNoWrapper';

const StoryBody = () => {
  const [on, setBannerOn] = useState(true);
  const noWrapper = useNoWrapper();

  const { asPath } = useRouter();

  const noCover = asPath.includes('no_cover');

  return (
    <Flex flexDirection="column" style={{ minHeight: '100vh', background: '#f8f8f8' }}>
      {!noWrapper && <CtaHeader />}
      {!noCover && <CoverHeader />}
      <Box bg="background" pb={40}>
        {!noCover && <StorySocialCount />}
        <StoryPages pt={noCover && 3} />
        {!noWrapper && <CtaFooter on={on} setBannerOn={setBannerOn} />}
      </Box>
      {!noWrapper && <CtaBanner on={on} />}
    </Flex>
  );
};

export default StoryBody;
